// English translation

const en = {};

export default en;
